import { Card, CardContent, Skeleton, Slide } from "@mui/material";
import React from "react";

export const TransitionSlideUp = React.forwardRef(
  function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  },
);

export const CardSkeleton = () => {
  return (
    <Card sx={{ borderRadius: 2 }}>
      <Skeleton variant="rectangular" height={100} />
      <CardContent>
        <Skeleton variant="text" width="80%" />
        <Skeleton variant="text" width="60%" />
      </CardContent>
    </Card>
  );
};
